import { useEffect, useMemo, useState } from 'react';
import { useRelayEnvironment } from 'react-relay';
import { useCurrentUser } from '@atlassian/jira-platform-services-user-current';
import { useLicensedProducts, useCloudId } from '@atlassian/jira-tenant-context-controller';
import { fetchDefinitionsPermissions } from '../../services/fetch-definitions-permissions';
import { setSessionStorageData, getSessionStorageData } from './utils';

export const useUserHasConfluenceAccess = () => {
	const { data: currentUser } = useCurrentUser();
	const storageKey = `jira-definition-user-has-confluence-access-agg-${currentUser.user.accountId}`;
	const cachedData = useMemo(() => getSessionStorageData(storageKey), [storageKey]);
	const [hasAccess, setHasAccess] = useState(Boolean(cachedData));
	const cloudId = useCloudId();
	const environment = useRelayEnvironment();

	const licensedProducts = useLicensedProducts();
	const hasConfluence = !!licensedProducts.confluence;

	useEffect(() => {
		if (!hasConfluence) return;

		const getConfluenceAccessPermissions = async () => {
			const response = await fetchDefinitionsPermissions(cloudId, environment);
			setSessionStorageData(storageKey, response);
			setHasAccess(Boolean(response));
		};

		if (cachedData === undefined) {
			getConfluenceAccessPermissions();
		} else {
			setHasAccess(cachedData);
		}
	}, [hasConfluence, storageKey, cachedData, environment, cloudId]);
	return { hasAccess };
};
